import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allStudents,
    allTournamentList,
    fetchTournamentList,
    addTournamentProcess,
 } from 'Actions';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
        this.props.allTournamentList();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            tournament:'', 
            seldate:'', 
            student:this.props.data.student,      
            country:'',
            drvsh_1:'',
            drvsc_1:'',
            fwsh_1:'',
            fwsc_1:'',
            apssh_1:'',
            apssc_1:'',
            wpsh_1:'',
            wpsc_1:'',
            bpsh_1:'',
            bpsc_1:'',
            chpsh_1:'',
            chpsc_1:'',
            putsh_1:'',
            putsc_1:'',
            spssh_1:'',
            spssc_1:'',
            errors: {}
        };
    }

    validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!this.state.student) {
            errors.student = 'Please select a student';
            isValid = false;
        }

        if (!this.state.tournament) {
            console.log(this.state.tournament);
            errors.tournament = 'Please select a tournament';
            isValid = false;
        }


        this.setState({ errors });
        return isValid;
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }

    selclub = (evt) =>{
        var clubid =evt.value;
        this.setState({ tournament:clubid });

        this.props.fetchTournamentList(clubid).then((data) => {   
            var resdata=data.data;
            this.setState({ 
               
                seldate:new Date(resdata[0].gtl_date),  
                country:resdata[0].gtl_country, 
              });


            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    addHandleSubmit(event){
        event.preventDefault();
        if (this.validateForm()) {  
            this.props.addTournamentProcess(event).then((data) => {   
            
                if(data.status==1){                    
                    this.setState({ 
                        student:'',
                        seldate:'',
                        tournament:'',
                    });

                    document.getElementById("addform").reset(); 
                    setTimeout(() => {
                        this.props.onClick();
                    }, 2000);                   
                }
            });
        }   
        
    }  

    handleNumberic(e) {               
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        } 
    }

    handleChange(e, id, frmname) {
        if(id==1){
            var selvalue=e.target.value;
            this.setState({ 
                [frmname]:selvalue
             });
        }else if(id==2){
            var selvalue=e.target.value;
            var prevalue=this.state[frmname]; 
            
            if(parseInt(selvalue)<=parseInt(prevalue)){
                var succvalue=selvalue;
            }else{
                var succvalue="";
            }
            var prrva=e.target.name;
            this.setState({ 
                [prrva]:succvalue
             });
        }
    }


render() {

    const { studentlists, tournamentalllist, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
  });

    const alltournament=tournamentalllist.map((stdval) => {  
        return {
           label: stdval.gtl_name,  
           value: stdval.gtlID
        }
    });
    const stdrole=localStorage.getItem('stdrole');
      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Create Tournament Process">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-md-7"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent}  rules={{ required: 'Please select an student'}} value={stdrole==1? allstudent[0] : allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                    {this.state.errors.student && <span className="text-danger">{this.state.errors.student}</span>}
                                                </FormGroup>
                                        </div> 
                                        <div className="col-sm-12 col-md-6">
                                                <Label for="course">Tournament *</Label>
                                                <FormGroup>
                                                <Label for="course">Tournament *</Label>
                                                    <Selectsearch placeholder="Select the tournament" id="tournament" name="tournament" options={alltournament} value={alltournament.find(obj => obj.value === this.state.tournament)} onChange={this.selclub} required/>
                                                    {this.state.errors.tournament && <span className="text-danger">{this.state.errors.tournament}</span>}
                                                </FormGroup>
                                        </div>  
                                        <div className="col-sm-12 col-md-6">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                         
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="country">Country *</Label>
                                                <input type="text" name="country" id="country" className="form-control form-control-alternative" defaultValue={this.state.country} required/>
                                            </FormGroup>  
                                        </div>
                                        <div className="col-sm-12 col-md-6">   
                                            <FormGroup>
                                                <Label for="Select">Round *</Label>
                                                    <select name="round" id="round" className="form-control form-control-alternative" required>
                                                          <option value=""></option>
                                                          <option value="1">1</option>
                                                          <option value="2">2</option>
                                                          <option value="3">3</option> 
                                                          <option value="4">4</option>                                                         
                                                    </select>
                                            </FormGroup>  
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <div className="table-responsive">
                                                <Table>
                                                    <TableHead>
                                                        <TableRow hover>                                                           
                                                            <TableCell align="center">SHOT TYPE</TableCell>
                                                            <TableCell align="center">SHOTS PLAYED</TableCell>
                                                            <TableCell align="center">SUCCESSFUL</TableCell>
                                                            <TableCell align="center">NOTES</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>DRIVING</TableCell>
                                                            <TableCell><input type="text" name="drvsh_1" id="drvsh_1" value={this.state.drvsh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'drvsh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="drvsc_1" id="drvsc_1" value={this.state.drvsc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'drvsh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="drvnote_1" id="drvnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow> 
                                                        <TableRow>
                                                            <TableCell>FWAY WOODS</TableCell>
                                                            <TableCell><input type="text" name="fwsh_1" id="fwsh_1" value={this.state.fwsh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'fwsh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="fwsc_1" id="fwsc_1" value={this.state.fwsc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'fwsh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="fwnote_1" id="fwnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow>   
                                                        <TableRow>
                                                            <TableCell>APPROACH SHOTS</TableCell>
                                                            <TableCell><input type="text" name="apssh_1" id="apssh_1" value={this.state.apssh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'apssh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="apssc_1" id="apssc_1" value={this.state.apssc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'apssh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="apsnote_1" id="apsnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow> 
                                                        <TableRow>
                                                            <TableCell>WEDGE PLAY</TableCell>
                                                            <TableCell><input type="text" name="wpsh_1" id="wpsh_1" value={this.state.wpsh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'wpsh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="wpsc_1" id="wpsc_1" value={this.state.wpsc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'wpsh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="wpnote_1" id="wpnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell>BUNKER PLAY</TableCell>
                                                            <TableCell><input type="text" name="bpsh_1" id="bpsh_1" value={this.state.bpsh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'bpsh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="bpsc_1" id="bpsc_1" value={this.state.bpsc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'bpsh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="bpnote_1" id="bpnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow> 
                                                        <TableRow>
                                                            <TableCell>CHIPPING</TableCell>
                                                            <TableCell><input type="text" name="chpsh_1" id="chpsh_1" value={this.state.chpsh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'chpsh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="chpsc_1" id="chpsc_1" value={this.state.chpsc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'chpsh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="chpnote_1" id="chpnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow> 
                                                        <TableRow>
                                                            <TableCell>PUTTING</TableCell>
                                                            <TableCell><input type="text" name="putsh_1" id="putsh_1" value={this.state.putsh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'putsh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="putsc_1" id="putsc_1" value={this.state.putsc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'putsh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="putnote_1" id="putnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow>  
                                                        <TableRow>
                                                            <TableCell>SPECIALITY</TableCell>
                                                            <TableCell><input type="text" name="spssh_1" id="spssh_1" value={this.state.spssh_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 1, 'spssh_1')}/></TableCell>
                                                            <TableCell><input type="text" name="spssc_1" id="spssc_1" value={this.state.spssc_1} className="form-control form-control-alternative" onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(e, 2, 'spssh_1')}/></TableCell>
                                                            <TableCell><textarea rows="2" type="text" name="spsnote_1" id="spsnote_1" className="form-control form-control-alternative"></textarea></TableCell>
                                                        </TableRow>
                                                        
                                                    </TableBody>
                                                </Table>   
                                            </div>  
                                            </div>       
                                        </div>

                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />  
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused, tournamentlist}) => {
    const { studentlists, loading } = mostlyused;
    const { tournamentalllist } = tournamentlist;
    return { studentlists, tournamentalllist, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    allTournamentList,
    fetchTournamentList,
    addTournamentProcess,
})(AddItems);
